import { CHANGE_MULTIPLE } from '../constants'

export default () => async (dispatch, getState) => {
  const state = getState()
  const { form: { searchFilters: { rooms } } } = state
  const isMultipleBooking = (rooms?.length > 1)

  dispatch({
    type: CHANGE_MULTIPLE,
    isMultipleBooking,
  })
}
